var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Dialog as MuiDialog, DialogTitle, DialogContent, DialogContentText, IconButton, useTheme, } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CloseDialogIcon } from './atoms/Icons';
var Dialog = styled(MuiDialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiPaper-root {\n    min-width: 300px;\n  }\n\n  .MuiDialogTitle-root {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .MuiDialogContent-root {\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n"], ["\n  .MuiPaper-root {\n    min-width: 300px;\n  }\n\n  .MuiDialogTitle-root {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .MuiDialogContent-root {\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n"])));
var GlobalDialog = function () {
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState(''), title = _b[0], setTitle = _b[1];
    var _c = React.useState(''), body = _c[0], setBody = _c[1];
    var theme = useTheme();
    var fullScreen = useMediaQuery(theme.breakpoints.down('md')) ? true : false;
    var handleReceiveMessage = React.useCallback(function (event) {
        if (window.origin !== window.location.origin)
            return;
        if (typeof event.data === 'object' && event.data.action === 'open-dialog') {
            setOpen(true);
            setTitle(event.data.title);
            setBody(event.data.body);
        }
    }, []);
    React.useEffect(function () {
        window.addEventListener('message', handleReceiveMessage);
        return function () {
            window.removeEventListener('message', handleReceiveMessage);
        };
    });
    var handleClose = React.useCallback(function () {
        setOpen(false);
    }, []);
    return (React.createElement(Dialog, { fullScreen: fullScreen, open: open, onClose: handleClose, "aria-labelledby": "global-dialog-title", "aria-describedby": "global-dialog-description" },
        React.createElement(DialogTitle, { id: "global-dialog-title" },
            title,
            React.createElement(IconButton, { onClick: handleClose, size: "large" },
                React.createElement(CloseDialogIcon, null))),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { id: "global-dialog-description" }, body))));
};
export default GlobalDialog;
var templateObject_1;
